module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7ce6b51fdb86dcf8b994bb5ddd9c666b.png";